import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getNewToken, getStatsReady } from "services";
import { E_Route } from "utils/constants";

export async function useAuth() {
  const navigate = useNavigate();

  useEffect(() => {
    getNewToken().then((token) => {
      const statsReady = getStatsReady();
      if (!token) {
        navigate(E_Route.AuthBegin);
        return;
      }
      if (!statsReady) {
        navigate(E_Route.AuthContinue);
      }
    });
  }, [navigate]);
}
